export const formatNumberWithSpaces = (number: number): string => number.toLocaleString('ru-RU');
